<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white;">
            <br/>
            <div class="col-sm-12 col-xs-12">
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>วันที่เริ่มผลิต</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12 form-inline">
                        <date-picker
                            v-model="form.start_date"
                            type="date"
                            :format="changeFormat"
                            :lang="lang"
                            class="w-50"
                            placeholder="วันที่เริ่มผลิต">
                        </date-picker>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>เวลาที่เริ่มผลิต</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="time"
                               v-model="form.start_time"
                               class="form-control w-50"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row style="margin-bottom: 20px">
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>กะ เริ่มต้น</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <b-form-select
                            v-model="form.shift_start"
                            class="col-sm-6"
                            :options="optionShift">
                        </b-form-select>
                    </b-col>
                </b-row>
                <!--                <b-row style="margin-bottom: 20px">-->
                <!--                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                <!--                        <label>กลุ่ม</label>-->
                <!--                    </b-col>-->
                <!--                    <b-col sm="6" class="col-sm-6 col-xs-12">-->
                <!--                        <b-form-select-->
                <!--                                v-model="form.group_id"-->
                <!--                                class="col-sm-6"-->
                <!--                                :options="Group">-->
                <!--                        </b-form-select>-->
                <!--                    </b-col>-->
                <!--                </b-row>-->
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>รหัสสินค้า</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12" style="padding: 0 30px 0 0">
                        <multiselect
                            v-model="form.products"
                            :options="optionProduct"
                            label="sku"
                            class="col-sm-6"
                            :multiple="true"
                            :max="1"
                            @input="getSheetByProduct(form.products)"
                            :show-labels="false"
                            placeholder="เลือกรหัสสินค้า"
                            track-by="sku">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ชีท</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12" style="padding: 0 30px 0 0">
                        <multiselect
                            v-model="form.sheet"
                            :options="sheet_product"
                            class="col-sm-6"
                            :customLabel="sheetCodeWithName"
                            :show-labels="false"
                            placeholder="เลือกชีท"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>เครื่องขึ้นรูป</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12" style="padding: 0 30px 0 0">
                        <multiselect
                            v-model="form.machine"
                            :options="optionMachine"
                            label="name"
                            :show-labels="false"
                            class="col-sm-6"
                            placeholder="เลือกเครื่องผลิตชีท"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>จำนวนตัว</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="number" class="form-control col-sm-6"
                               v-model="form.quantity_for_machine"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>ช็อต/วินาที</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input type="number" class="form-control col-sm-6"
                               v-model="form.time_shot"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>จำนวน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12 form-inline form-group">
                        <input
                            v-model="form.quantity"
                            placeholder="ม้วน"
                            type="number"
                            class="form-control col-sm-6"/>
                        &nbsp;
                        <span>แพ็ค</span>
                    </b-col>
                </b-row>
                <!--<b-row>-->
                <!--<b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>วันที่สิ้นสุดการผลิต</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12">-->
                <!--<datepicker placeholder="ไม่ระบุ" :bootstrap-styling="true"-->
                <!--class="col-sm-6"-->
                <!--v-model="form.end_date">-->
                <!--</datepicker>-->
                <!--<br/>-->
                <!--</b-col>-->
                <!--</b-row>-->
                <!--<b-row v-if="form.end_date">-->
                <!--<b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>เวลาที่สิ้นสุดการผลิต</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12" style="margin-left: 15px">-->
                <!--<input-->
                <!--type="time"-->
                <!--class="form-control col-sm-6"-->
                <!--v-model="form.end_time"/>-->
                <!--<br />-->
                <!--</b-col>-->
                <!--</b-row>-->
                <!--<b-row v-if="form.end_date" style="padding-bottom: 20px">-->
                <!--<b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>กะ สิ้นสุด</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12" style="margin-left: 15px">-->
                <!--<b-form-select-->
                <!--v-model="form.shift_end"-->
                <!--class="col-sm-6"-->
                <!--:options="optionShift">-->
                <!--</b-form-select>-->
                <!--<br />-->
                <!--</b-col>-->
                <!--</b-row>-->
                <b-row>
                    <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                        <label>หมายเหตุ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <textarea
                            v-model="form.reason"
                            class="form-control col-sm-6"
                        ></textarea>
                    </b-col>
                </b-row>
                <br/>
                <template v-if="this.id!=null">
                    <b-row>
                        <b-col sm="4" xs="12" class="col-sm-4 col-xs-12 text-right">
                            <label>ปัญหาการผลิต</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6 col-xs-12">
                        <textarea
                            v-model="form.problem"
                            class="form-control col-sm-6"
                        ></textarea>
                        </b-col>
                    </b-row>
                </template>
                <br/>
                <b-form inline>
                    <label class="col-4"/>
                    <div class="col-sm-6 form-button">
                        <b-button :disabled="form.onSave"
                                  variant="success"
                                  @click="saveProductReport">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button class="btn btn-outline-secondary"
                                  @click="goToProductReportList">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button v-if="id"
                                  class="btn btn-danger"
                                  @click="showModalDelete">
                            <icon name="trash-alt" style="width: 25px"></icon>
                            ลบ
                        </b-button>
                    </div>
                </b-form>
            </div>
            <br/>
        </div>
        <!-- ----Modal Delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteProductReport">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ form }}</pre>-->
    </div>
</template>

<script>
import HeaderTitle from "../../HeaderTitle";
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import InputGroup from "bootstrap-vue/es/components/input-group/input-group";
import moment from "moment";
import DatePicker from 'vue2-datepicker'

export default {
    components: {
        InputGroup,
        HeaderTitle,
        Multiselect,
        DatePicker
    },
    props: {
        id: {default: null}
    },
    name: "production-report-information",
    data() {
        return {
            optionShip: [
                {value: "", text: "กรุณาเลือกกะ"},
                {value: "กลางวัน", text: "กลางวัน"},
                {value: "กลางคืน", text: "กลางคืน"}
            ],
            items: [
                {
                    text: "รายการสั่งผลิตสินค้า",
                    to: {name: "production-report"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            Group: [
                {value: null, text: "กรุณาเลือกกลุ่ม"},
                {value: 1, text: "A"},
                {value: 2, text: "B"}
            ],
            time: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        //console.log(this.id);
        this.time = moment().locale('TH').format('LT');
        //console.log(this.time);
        if (!this.id) {
            this.$store.dispatch("ReportProduct/clearFormData");
        }
        this.$store.dispatch("Machine/get");
        this.$store.dispatch('Common/setShiftWork')
    },
    computed: {
        ...mapState({
            optionProduct: state => {
                return state.Products.product_all;
            },
            optionMachine: state => {
                return state.Machine.data;
            },
            form: state => {
                return state.ReportProduct.Form;
            },
            user: state => {
                return state.Auth.user;
            },
            optionShift: state => {
                return [
                    {
                        value: null,
                        text: "กรุณาเลือกกะ"
                    },
                    ...state.Common.shift_work.map(shift => ({
                        value: shift,
                        text: shift.name
                    }))
                ];
            },
            sheet_product: state => {
                return state.ReportProduct.sheet_product;
            }
        })
    },
    methods: {
        sheetCodeWithName({code, name}) {
            return `${name} - ${code}`
        },
        saveProductReport() {
            if (!this.form.products) {
                alert('กรุณารายการสินค้า')
            } else if (!this.form.sheet) {
                alert('กรุณาเลือกชีท');
            } else if (!this.form.machine) {
                alert('กรุณาเลือกเครื่อง');
            } else if (!this.form.start_date) {
                alert("กรุณากรอกวันที่เริ่มต้น");
            } else if (!this.form.shift_start) {
                alert("กรุณากรอกกะเริ่มต้น");
            } else if (this.form.quantity < 1 && this.form.quantity) {
                alert("กรุณาใส่จำนวนให้ถูกต้อง")
            }
                // else if(!this.form.group_id){
                //     alert("กรุณาเลือกกลุ่ม")
            // }
            else {
                if (this.form.start_date) {
                    this.form.start_date = moment(this.form.start_date).format("YYYY-MM-DD");
                }
                if (this.form.end_date) {
                    this.form.end_date = moment(this.form.end_date).format("YYYY-MM-DD");
                }
                this.form.user = this.user.name;
                this.form.onSave = true;
                this.$store.dispatch("ReportProduct/save", this.id).then(() => {
                    this.goToProductReportList();
                });
            }
        },
        showModalDelete() {
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        deleteProductReport() {
            this.$store.dispatch("ReportProduct/delete", this.id).then(() => {
                this.hideModalDelete();
                this.goToProductReportList();
            });
        },
        goToProductReportList() {
            this.$router.push({name: "production-report"});
            this.form.onSave = false;
        },
        getSheetByProduct(product) {
            //console.log(product.code);
            if (product) {
                this.$store.dispatch("ReportProduct/getSheetProduct", product.code);
            }
        }
    }
};
</script>

<style scoped>
.form-button {
    /*margin-left: 20%;*/
    display: flex;
    padding: 0;
}
</style>
